import { SWReactIcons } from "@similarweb/icons";
import { Text } from "@similarweb/ui-components/foundations";

import { Truncate } from "../Truncate";

import { ColumnSelect } from "./ColumnSelect";

interface IColumnMappingItemProps {
    label: string;
    options: string[];
    selectedIndex: number;
    disabledIndexes?: number[];
    onChange: (newIndex: number) => void;
    previewData: string[][];
    hasHeaders: boolean;
}

export const ColumnMappingItem = ({
    label,
    options,
    selectedIndex,
    disabledIndexes,
    onChange,
    previewData,
    hasHeaders,
}: IColumnMappingItemProps) => {
    return (
        <>
            <Text fontVariant="input2">{label}</Text>

            <SWReactIcons
                iconName="arrow-right"
                size="sm"
            />

            <ColumnSelect
                options={options}
                selectedIndex={selectedIndex}
                disabledIndexes={disabledIndexes}
                onChange={onChange}
            />

            {selectedIndex !== -1 ? (
                <Truncate>
                    <Text fontVariant="input2">{previewData[hasHeaders ? 1 : 0][selectedIndex]}</Text>
                </Truncate>
            ) : (
                "\u00A0"
            )}
        </>
    );
};
